import { 
  EVENTS_LIST_REQUEST,
  EVENTS_LIST_SUCCESS,
  EVENTS_LIST_FAILURE,
  EVENTS_AGG_REQUEST,
  EVENTS_AGG_SUCCESS,
  EVENTS_AGG_FAILURE,
} from '../actions/eventsActions';

const initialState = {
  listLoading: false,
  listError: null,
  events: [],
  nextCursor: '',
  hasMore: false,
  lastListFetchedAt: null,

  aggregateLoading: false,
  aggregateError: null,
  aggregate: null,
  lastAggregateFetchedAt: null,
};

export default function eventsReducer(state = initialState, action) {
  switch (action.type) {
    case EVENTS_LIST_REQUEST:
      return { ...state, listLoading: true, listError: null };
    case EVENTS_LIST_SUCCESS: {
      const envelope = action.payload || {};
      const data = envelope?.data ?? envelope;
      const events = Array.isArray(data?.events) ? data.events : (Array.isArray(data) ? data : []);
      const pagination = data?.pagination || {};
      const nextCursor = pagination?.nextCursor || envelope?.nextCursor || '';
      const hasMore = !!(pagination?.hasMore);
      return {
        ...state,
        listLoading: false,
        listError: null,
        events,
        nextCursor,
        hasMore,
        lastListFetchedAt: Date.now(),
      };
    }
    case EVENTS_LIST_FAILURE:
      return { ...state, listLoading: false, listError: action.error };

    case EVENTS_AGG_REQUEST:
      return { ...state, aggregateLoading: true, aggregateError: null };
    case EVENTS_AGG_SUCCESS:
      return {
        ...state,
        aggregateLoading: false,
        aggregateError: null,
        aggregate: action.payload || null,
        lastAggregateFetchedAt: Date.now(),
      };
    case EVENTS_AGG_FAILURE:
      return { ...state, aggregateLoading: false, aggregateError: action.error };
    default:
      return state;
  }
}


